/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) System ViewHistory Icon component.
 */
export const SystemViewHistoryIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='SystemViewHistoryIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M3.47 10.091a9.25 9.25 0 11.58 6M12.06 9v4.64l3.21 2.35'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          strokeLinecap='round' />
        <path d='M6.5 10.49l-3.36.36L2 8'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          strokeLinecap='round' />
      </svg>
    )} />
  );
};
